<template>
    <b-container class="overlay" fluid>
        <b-row v-if="!landingDisplay" class="overlay-top" align-h="between">
            <b-col class="left" col xs="1" sm="1" md="1" xl="6" lg="6">
                <a href="javascript:void(0);" @click="goto('/')"><img :class="{ 'logo': !darkClass, 'logo-dark': darkClass }" alt="ozmo logo blanco" src="../assets/ozmo_logo.svg"></a>
            </b-col>
            <b-col class="right"  col xs="2" sm="2" md="2" xl="6" lg="6">
                <a href="javascript:void(0);" v-if="!privacyDisplay && !cookiesDisplay" @click="displayNavigation"><b-icon icon="list" class="menu"></b-icon></a>
                <a href="javascript:void(0);" v-if="cookiesDisplay || privacyDisplay" @click="goto('/')"><b-icon class="dark" icon="x"></b-icon></a>
            </b-col>
        </b-row>

        <b-row v-if="!landingDisplay" class="overlay-bottom" align-h="between" align-v="end" :style="overlayOffset" :class="{ 'overlay-offset': (futuresDisplay || presentDisplay || privacyDisplay)}">
            <b-col cols="12">
                <b-row>
                    <b-col class="left" col xs="12" sm="12" md="12" xl="6" lg="6">
                        <!-- <p :class="{ 'slogan': true, 'dark': darkClass }">Consultoría en Transformación Estratégica</p> -->
                    </b-col>
                    <b-col class="right copyright" col xs="12" sm="12" md="12" xl="6" lg="6">
                        <!-- <b-button v-if="!privacyDisplay && !cookiesDisplay" class="ozmo-btn-outline contact" @click="launchContact">Contáctanos</b-button> -->
                    </b-col>
                </b-row>
                <b-row v-if="homeDisplay">
                    <b-col class="privacy" cols="12">
                        <b-row align-h="between">
                            <b-col cols="10">
                                <p>Esta pagina emplea cookies de terceros y propias. Si quieres conocer más te invitamos a leer nuestra <a href="javascript:void(0);" @click="goto('/cookies')">Politica de cookies</a>. Al seguir navegando aceptas la politica de cookies.</p>
                            </b-col>
                            <b-col cols="2">
                                <p><b-icon class="close my-2" icon="x" @click="closeCookiePolicy"></b-icon></p>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>

import { eventBus } from '../main'
import * as typeformEmbed from '@typeform/embed'

import { gsap } from "gsap"
import { TimelineLite, Sine } from "gsap"

gsap.registerPlugin()

export default {
    data() {
        return {
            timeline_policy: ''
        }
    },
    computed: {
        overlayOffset() {
            let offset = this.$store.getters.getWindowHeight - 80 //original footer height
            return {
                '--offset': offset + 'px'
            }
        },
        homeDisplay() {
            return this.$route.name === 'Home'
        },
        servicesDisplay() {
            return this.$route.name === 'Services'
        },
        futuresDisplay() {
            return this.$route.name === 'Future'
        },
        presentDisplay() {
            return this.$route.name === 'Present'
        },
        prospectDisplay() {
            return this.$route.name === 'Prospector'
        },
        privacyDisplay() {
            return this.$route.name === 'Privacy'
        },
        cookiesDisplay() {
            return this.$route.name === 'Cookies'
        },
        landingDisplay() {
            return (this.$route.name === 'LandingCovid' || this.$route.name === 'LandingMta')
        },
        // lightClass() {
        //     return this.$route.name === 'Home'
        // },
        darkClass() {
            return (this.$route.name === 'Cookies' || this.$route.name === 'Privacy')
        }
    },
    mounted() {
        this.timeline_policy = new TimelineLite()

        this.timeline_policy.fromTo('.privacy', 1, {display:'none',autoAlpha:0}, {
            ease: Sine.easeInOut,
            autoAlpha: 1,
            display: 'initial',
        })
        // console.log(this.$route.name)
    },
    methods: {
        closeCookiePolicy() {

            this.timeline_policy.to('.privacy', 0.5, {
                ease: Sine.easeInOut,
                autoAlpha:0,
                display:'none',
            })
        },
        displayNavigation() {
            eventBus.$emit('displayNavigation')
        },
        goto(navigation) {
            eventBus.$emit('gotoNavigation', navigation)
        },
        launchContact() {
            typeformEmbed.makePopup(
                // `https://ozmomx.typeform.com/to/dTWHb81Q?source=web-${this.$route.name}`,
                // 'https://ozmomx.typeform.com/to/YPa8WK93?utm_source=website&utm_medium=section&utm_campaign=website2022&utm_content=overlay',
                'https://www.cognitoforms.com/Kinit1/ContactoWeb?entry={"Leads":{"Ref":"website-overlay"}}',
                {
                    mode: 'drawer_right',
                    autoOpen: true,
                    autoClose: 15,
                    hideScrollbars: true,
                    onSubmit: function () {}
                }
                )
        }
    }
}
</script>

<style scoped lang="stylus">

.overlay
    overflow-y scroll
    overflow hidden

    .logo, .menu, .contact, .dark, .logo-dark
        pointer-events auto

.overlay-top
    line-height 72px
    padding-top 3rem
    width 100vw
    position absolute
    z-index 10
    pointer-events none

    .right
        text-align right
        padding-right 5rem

    .left
        text-align left
        padding-left 5rem

.overlay-bottom
    line-height 72px
    position absolute
    width 100%
    bottom 0
    z-index 10
    pointer-events none

    .right
        text-align right
        padding-right 5rem
        padding-bottom 3rem

    .left
        text-align left
        padding-left 5rem

    .privacy
        pointer-events all
        padding-left 5rem
        padding-right 2rem
        height 72px
        background-color #FFFFFF

        p
            margin-bottom 0
            line-height 72px
            txt_style($worksans-r, 12px, $ozmo-gray)

        a
            color $ozmo-coral
            text-decoration underline

        .close
            cursor pointer
            txt_style($worksans-r, 60px, $ozmo-gray)

.overlay-offset
    margin-top var(--offset)

.slogan
    txt_style($worksans-m, 16px, #FFFFFF)

.b-icon
    txt_style($worksans-m, 60px, #FFFFFF)

.logo
    width 144px
    filter brightness(0) invert(1)

.logo-dark
    width 144px
    filter brightness(0)

.top-btn
    margin-right 10rem
    margin-top -5rem

.dark
    color #000000


@media (max-width 768px)
    .overlay-bottom

        .privacy
            pointer-events all
            padding-left 2rem
            padding-right 3rem
            padding-bottom 1rem
            height 100%
            background-color #FFFFFF

            p
                padding-top 2rem
                margin-bottom 0
                line-height 22px
                txt_style($worksans-r, 12px, $ozmo-gray)

            a
                color $ozmo-coral
                text-decoration underline

            .close
                cursor pointer
                txt_style($worksans-r, 36px, $ozmo-gray)

    .slogan
        txt_style($worksans-m, 12px, #FFFFFF)
        text-align center

    .copyright
        display none
    .logo
        padding-top 2rem
        padding-left 1rem

    .overlay-top
        background-color rgba(0,0,0,0.6)
        line-height 42px
        padding-top 1rem

        .right
            text-align right
            padding-right 1px

            .x
                padding-bottom 15px

        .left
            text-align left
            padding-left 1px

    .top-btn
        display none
</style>